import { createSelector } from 'reselect';

const selectOrderPolicy = (state: any) => state.orderPolicies;


export const selectOrderPolicyCurrentItem = createSelector([selectOrderPolicy], (orderPolicies) => orderPolicies.current);

export const selectOrderPolicyListItems = createSelector([selectOrderPolicy], (orderPolicies) => orderPolicies.list);

export const selectOrderPolicyItemById = (itemId: any) =>
    createSelector(selectOrderPolicyListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectOrderPolicyQueryItems = createSelector([selectOrderPolicy], (orderPolicies) => orderPolicies.query);

export const selectOrderPolicyCreatedItem = createSelector([selectOrderPolicy], (orderPolicies) => orderPolicies.create);

export const selectOrderPolicyUpdatedItem = createSelector([selectOrderPolicy], (orderPolicies) => orderPolicies.update);

export const selectOrderPolicyReadItem = createSelector([selectOrderPolicy], (orderPolicies) => orderPolicies.read);

export const selectOrderPolicyDeletedItem = createSelector([selectOrderPolicy], (orderPolicies) => orderPolicies.delete);

export const selectOrderPolicySearchedItems = createSelector([selectOrderPolicy], (orderPolicies) => orderPolicies.search);

export const selectOrderPolicyItemsCount = createSelector([selectOrderPolicy], (orderPolicies) => orderPolicies.count);

export const selectOrderPolicyItemsFilter = createSelector([selectOrderPolicy], (orderPolicies) => orderPolicies.filter);